export default __webpack_public_path__ + "static/media/pokedex.c951a91d.png";